up.compiler(".up_workshop_tr", function (element) {
  const linkto = element.querySelector(".js-linkto");

  async function onClick() {
    await up.follow(linkto);
  }

  element.addEventListener("click", onClick);
  return () => {
    element.removeEventListener("click", onClick);
  };
});
